<template>
  <section class="component-background sm:flex sm:flex-col gap-y-4 pb:grid min-h-screen xl:grid-cols-0 md:grid-cols-0 relative">
    <div class="ilustracoes-container absolute left-0 top-1/2 -translate-y-1/2 z-0">
        <img src="/images/ilustrações.png" class="w-full h-auto" />
    </div>
    <Heading v-if="headingTitle" :title="headingTitle" class="px-4 pb:hidden"/>
    <div>
        <article class="flex flex-col justify-center items-center w-full px-8 pb:mt-[15vh]">
            <img src="/images/logo.png" class="object-cover mt-[160px] ml-[50px] z-10 logo-slogan-mobile" />
            <img src="/images/slogan.png" class="object-cover mt-10 max-w-[45%] logo-slogan-mobile" />
        </article>
    </div>  
    <div class="grid xl:content-start sm:items-start pt-2">
      <Header :showExtras="showExtras" :showBackButton="showBackButton"/>
      <div class="sm:block flex justify-center pb-20 pb:mt-[16vh]">
        <slot />
      </div>
      <div v-if="showHyperLinks">
        <!-- <HyperLinksList class="self-end sm:hidden" /> -->
      </div>
    </div>
    <BottomBar :class="{'pb:hidden' : !showBottomBarInDesktop, 'sm:hidden' : !showBottomBarInMobile}"/>
  </section>
  <Footer v-if="showFooter" />
</template>

<script>
import Header from "@/Components/UI/Nav/Header.vue";
import Footer from "@/Components/Footer.vue";
import HyperLinksList from "@/Components/HyperLinksList.vue";
import BottomBar from "@/Components/BottomBar.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';

export default {
  components: {
    Header,
    Footer,
    HyperLinksList,
    BottomBar,
    Heading,
  },
  props: {
    headingTitle: {
      type: String,
      default: "",
    },
    showExtras: Boolean,
    showFooter: {
      type: Boolean,
      default: false,
    },
    showHyperLinks: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
    showBottomBarInDesktop: {
      type: Boolean,
      default: false,
    },
    showBottomBarInMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
    /* Ilustrações responsivo */
    .ilustracoes-container { width: 250px; }

    @media (min-width: 1435px) {
        .ilustracoes-container { display: none; }
        .logo-slogan-mobile { display: none; }
    }
</style>
